export const WHATSAPP_MESSAGE =
  "السلام عليكم ورحمة الله و بركاتة، وصلت إليكم من خلال موقع النجوم المميزة للاستقدام، وأرغب في الاستفسار عن خدمات الاستقدام والعروض المتاحة.";

export const buildWhatsAppUrl = (phone) =>
  `https://wa.me/${phone ?? ""}?text=${encodeURIComponent(WHATSAPP_MESSAGE)}`;
